import { EventStatus } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/calendar_event.pb';
import { i18next } from '@frontend/i18n';
import { IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { ChipVariants } from '@frontend/design-system';

interface ApptStatusInfo {
  label: string;
  icon: IconName;
  color: string;
  chipVariant: ChipVariants;
}

export const APPT_STATUS_INFO_MAP: Record<EventStatus, ApptStatusInfo> = {
  [EventStatus.ATTEMPTED]: {
    label: i18next.t('Attempted', { ns: 'appointment-status' }),
    icon: 'phone-missed-small',
    color: theme.colors.warning80,
    chipVariant: 'warn',
  },
  [EventStatus.CANCELED]: {
    label: i18next.t('Canceled', { ns: 'appointment-status' }),
    icon: 'block-small',
    color: theme.colors.critical50,
    chipVariant: 'critical',
  },
  [EventStatus.COMPLETED]: {
    label: i18next.t('Completed', { ns: 'appointment-status' }),
    icon: 'check-small',
    color: theme.colors.success50,
    chipVariant: 'success',
  },
  [EventStatus.CONFIRMED]: {
    label: i18next.t('Confirmed', { ns: 'appointment-status' }),
    icon: 'calendar-confirmed-small',
    color: theme.colors.primary50,
    chipVariant: 'primary',
  },
  [EventStatus.IN_OFFICE]: {
    label: i18next.t('In Office', { ns: 'appointment-status' }),
    icon: 'in-progress-small',
    color: theme.colors.secondary.seaweed50,
    chipVariant: 'seaweed',
  },
  [EventStatus.NO_SHOW]: {
    label: i18next.t('No Show', { ns: 'appointment-status' }),
    icon: 'user-x-small',
    color: theme.colors.critical50,
    chipVariant: 'critical',
  },
  [EventStatus.UNCONFIRMED]: {
    label: i18next.t('Unconfirmed', { ns: 'appointment-status' }),
    icon: 'pending-small',
    color: theme.colors.warning80,
    chipVariant: 'warn',
  },
  [EventStatus.UNKNOWN_EVENT_STATUS]: {
    label: i18next.t('Unknown', { ns: 'appointment-status' }),
    icon: 'info-small',
    color: theme.colors.neutral50,
    chipVariant: 'neutral',
  },
};
